import React, { useState } from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const PhotoGrid = ({ photos, onPhotoClick }) => {
  const [activeCategory, setActiveCategory] = useState('all');

  const categories = [
    { id: 'all', label: 'All Photos', icon: 'Images' },
    { id: 'food', label: 'Our Food', icon: 'UtensilsCrossed' },
    { id: 'ambiance', label: 'Restaurant', icon: 'Store' },
    { id: 'customers', label: 'Happy Customers', icon: 'Users' },
    { id: 'preparation', label: 'Behind The Scenes', icon: 'ChefHat' }
  ];

  const filteredPhotos = activeCategory === 'all' 
    ? photos 
    : photos?.filter(photo => photo?.category === activeCategory);

  return (
    <div className="w-full">
      <div className="flex overflow-x-auto gap-2 md:gap-3 pb-4 mb-6 md:mb-8 scrollbar-hide">
        {categories?.map((category) => (
          <button
            key={category?.id}
            onClick={() => setActiveCategory(category?.id)}
            className={`flex items-center gap-2 px-4 md:px-6 py-2 md:py-3 rounded-lg whitespace-nowrap transition-all duration-300 flex-shrink-0 ${
              activeCategory === category?.id
                ? 'bg-primary text-primary-foreground shadow-lg'
                : 'bg-card text-foreground hover:bg-muted'
            }`}
          >
            <Icon name={category?.icon} size={18} />
            <span className="text-sm md:text-base font-medium">{category?.label}</span>
          </button>
        ))}
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
        {filteredPhotos?.map((photo) => (
          <div
            key={photo?.id}
            onClick={() => onPhotoClick(photo)}
            className="group relative overflow-hidden rounded-lg cursor-pointer bg-card shadow-md hover:shadow-xl transition-all duration-300"
          >
            <div className="aspect-[4/3] overflow-hidden">
              <Image
                src={photo?.image}
                alt={photo?.imageAlt}
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
              />
            </div>
            
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
              <div className="absolute bottom-0 left-0 right-0 p-4 md:p-6 text-white">
                <h3 className="text-base md:text-lg font-bold mb-1 md:mb-2">{photo?.title}</h3>
                <p className="text-xs md:text-sm opacity-90 line-clamp-2">{photo?.description}</p>
                <div className="flex items-center gap-4 mt-3 md:mt-4 text-xs md:text-sm">
                  <div className="flex items-center gap-1">
                    <Icon name="Heart" size={16} />
                    <span>{photo?.likes}</span>
                  </div>
                  <div className="flex items-center gap-1">
                    <Icon name="Share2" size={16} />
                    <span>Share</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="absolute top-3 md:top-4 right-3 md:right-4 bg-primary text-primary-foreground px-2 md:px-3 py-1 rounded-full text-xs md:text-sm font-medium">
              {photo?.categoryLabel}
            </div>
          </div>
        ))}
      </div>
      {filteredPhotos?.length === 0 && (
        <div className="text-center py-12 md:py-16">
          <Icon name="ImageOff" size={48} className="mx-auto mb-4 text-muted-foreground" />
          <p className="text-muted-foreground text-sm md:text-base">No photos found in this category</p>
        </div>
      )}
    </div>
  );
};

export default PhotoGrid;